import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { convertToKebabCase } from '../../../utils/string-utils';
const b = bemClassBuilder('v-single-filter');
export const SingleFilterSkeleton = observer(({ displayMode }) => {
    return (_jsx("div", Object.assign({ className: b.block({ skeleton: true }) }, { children: _jsx("div", { className: b.element(convertToKebabCase(displayMode)) }) })));
});
SingleFilterSkeleton.displayName = 'SingleFilterSkeleton';
